import type { LocationErrors, Location } from '@toolbox/components/AddressSuggestField/types';

export const validateLocation = (location: Location, postalcode?: string) => {
  if (
    !location.postalCode?.trim() ||
    !location.city?.trim() ||
    !location.street?.trim() ||
    !location.number?.trim() ||
    (postalcode && location.postalCode !== postalcode)
  ) {
    return false;
  }
  return true;
};

// all errors in one string for single input
export const getLocationErrors = (
  location: Location,
  postalcode: string,
  errorsMap: LocationErrors,
) => {
  const error = [];
  if (!location.postalCode?.trim() || (postalcode && location.postalCode !== postalcode)) {
    error.push(errorsMap.postalCode);
  }
  if (!location.street?.trim()) {
    error.push(errorsMap.street);
  }
  if (!location.number?.trim()) {
    error.push(errorsMap.number);
  }
  if (!location.city?.trim()) {
    error.push(errorsMap.default);
  }
  return error.length === 1 && typeof error[0] === 'string' ? error[0] : errorsMap.default;
};

// errors for multiple inputs
export const getLocationAllErrorsMap = (
  location: Location,
  postalcode: string,
  errorsMap: LocationErrors,
) => ({
  default:
    !location.postalCode?.trim() || (postalcode && location.postalCode !== postalcode)
      ? errorsMap.postalCode
      : '',
  street: !location.street?.trim() ? errorsMap.street : '',
  number: !location.number?.trim() ? errorsMap.number : '',
});
